const clientRecordStatuses = {
  active: { id: 'active', name: 'No' },
  archived: { id: 'archived', name: 'Yes' },
};

export default clientRecordStatuses;
